/**
 * Set of function to validate and format data before modifying for edit appointment
 */
export const validateAndFormatBeforeEdit = {
  /**
   * Validate and format time
   * @param {Number} hh
   * @param {Number} mm
   * @param {Number} tt
   */
  time(hh, mm, tt) {
    if (isNaN(hh) || isNaN(mm) || isNaN(tt)) {
      return {
        hr: 10,
        min: 0,
        sec: 0
      };
    } else {
      hh = parseInt(hh);
      mm = parseInt(mm);
      tt = parseInt(tt);
      hh = hh === 12 ? 0 : hh;
      hh = tt === 1 ? (hh += 12) : hh;
      return {
        hr: hh,
        min: mm,
        sec: 0
      };
    }
  },
  /**
   * Validate and format provideId and return the selectedId
   * @param {Number} providerId
   * @param {Object} state
   */
  provider(providerId, state) {
    providerId = isNaN(providerId) ? false : parseInt(providerId);
    if (!providerId) {
      return false;
    }
    const selectedIndex = state.provider.list
      .map(provider => {
        return provider.id;
      })
      .indexOf(providerId);
    return selectedIndex === -1 ? false : selectedIndex;
  },
  /**
   * Validate and format appointment type
   * @param {Object} appointment
   * @param {Object} appointmentType
   */
  appointmentType(appointment) {
    // Step 1: Check if there is a selected provider id
    const providerID = isNaN(appointment["provider_id"])
      ? false
      : parseInt(appointment["provider_id"]);
    if (!providerID) {
      return {
        type: false,
        selectedId: false
      };
    }

    // Step 2: Differentiate between the contacts
    if (
      parseInt(appointment["client_id"]) !== 0 &&
      appointment["client_id"] !== null
    ) {
      // CLIENTs
      return {
        type: "person",
        selectedId: +appointment["client_id"]
      };
    } else if (appointment["otherevent_type"] === 1) {
      // PEOPLE
      return {
        type: "other_event",
        selectedId: +appointment["otherevent_id"]
      };
    } else if (appointment["otherevent_type"] === 0) {
      // EVENTS
      return {
        type: "event_appointment",
        selectedId: +appointment["otherevent_id"]
      };
    } else if (appointment["otherevent_type"] === 2) {
      return {
        type: "group_appointment",
        selectedId: +appointment["otherevent_id"]
      };
    }
  },
  /**
   * Validate and format repeat type
   * @param {Object} appointment
   */
  repeatType(appointment) {
    let index;
    let custom;
    let innerOrOuter;

    switch (appointment["repeat"]) {
      case 0:
        index = 0;
        custom = isNaN(appointment["repeat_freq"])
          ? 0
          : parseInt(appointment["repeat_freq"]);
        innerOrOuter = "inner";
        break;

      case 1:
        index = 1;
        custom = 0;
        innerOrOuter = "outer";
        break;

      case 2:
        index = 2;
        custom = 0;
        innerOrOuter = "outer";
        break;

      case 3:
        index = 3;
        custom = 0;
        innerOrOuter = "outer";
        break;

      case 4:
        index = 1;
        custom = isNaN(appointment["repeat_freq"])
          ? 0
          : parseInt(appointment["repeat_freq"]);
        innerOrOuter = "inner";
        break;

      case 5:
        index = 4;
        custom = 0;
        innerOrOuter = "outer";
        break;

      case 6:
        index = appointment["repeat_by"] === 0 ? 2 : 3;
        custom = isNaN(appointment["repeat_freq"])
          ? 0
          : parseInt(appointment["repeat_freq"]);
        innerOrOuter = "inner";
        break;

      case 7:
        index = 4;
        custom = isNaN(appointment["repeat_freq"])
          ? 0
          : parseInt(appointment["repeat_freq"]);
        innerOrOuter = "inner";
        break;

      default:
        index = 0;
        custom = 0;
        innerOrOuter = "outer";
    }

    return {
      index,
      custom,
      innerOrOuter
    };
  },
  /**
   *
   * @param {DateString} value - format yyyy - mm - dd
   */
  date(value) {
    if (value === "0000 - 00 - 00") {
      return {
        dayOfMonth: 0,
        month: 0,
        year: 0,
        never: true
      };
    } else {
      const dateArray = value.split("-");
      return {
        dayOfMonth: isNaN(dateArray[2]) ? 0 : parseInt(dateArray[2]),
        month: isNaN(dateArray[1]) ? 0 : parseInt(dateArray[1]) - 1,
        year: isNaN(dateArray[0]) ? 0 : parseInt(dateArray[0]),
        never: false
      };
    }
  }
};
